<template>
  <ElDialog
      v-model="isShow"
      :title="$t('customer.import.batch')"
      :footer="null"
      centered
      top="10em"
      :width="'40%'"
      style="min-width:600px"
      destroyOnClose
      @cancel="cancel"
      @close="close"
      :close-on-click-modal="false"
      :class="'headline'"
  >
    <el-upload
        ref="uploadRef"
        style="width: 100%;display: flex;justify-content: center;flex-direction: column;align-items: center;margin-top: 20px"
        class="upload-demo"
        :accept="['.xls','.xlsx']"
        :auto-upload="false"
        :show-file-list="true"
        :file-list="fileList1"
        :on-change="handleUploadChange"
        :on-remove="handleRemove"
    >
      <el-button v-if="fileList1.length < 1" type="primary" plain size="large"
                 style="border: 1px dashed #409eff;width: 250px;margin: auto ">
        {{ $t('system.select.file') }}
      </el-button>
    </el-upload>
    <div style="height: 8px;width: 100%;margin-bottom: 10px;">
      <el-progress :percentage="percent" v-if="percent!==0" striped :stroke-width="10"/>
    </div>
    <div style="display: flex;margin-top: 4px">
      <el-button plain size="large" style="border: 1px dashed #dddfe5;width: 250px;margin: auto " :icon="Download"
                 @click="downloadExcel" :loading="downloadFile">
        {{ $t('list.customer.download.template') }}
      </el-button>
    </div>
    <div class="import_message" v-show="isShowData">
      <span>{{ $t('import.txt.1') }} <strong>{{ importCustomerMessage?.totalCount }}</strong> {{
          $t('pagination.tiao')
        }}</span>{{ $t('import.txt.2') }}
      <span>{{ $t('common.import') }}{{ $t('0') }}<strong>{{
          importCustomerMessage?.successCount
        }}</strong> {{ $t('pagination.tiao') }}</span>，
      <span>{{ $t('common.failed.send') }} <strong>{{
          importCustomerMessage?.failCount
        }}</strong> {{ $t('pagination.tiao') }}</span>{{ $t('import.txt.3') }}
    </div>
    <div class="import_message" style="color: #c8453f;font-weight: 500" v-show="isErrorExcel">
      {{ $t('common.import.excel.error') }}
    </div>
    <div style="width: 100%;display: flex;justify-content: center;margin-top: 20px;margin-bottom: 20px">
      <div style="width: 85%" class="text_content">
        <p><span><el-icon size="16" style="margin-right: 5px"><Warning/></el-icon></span>{{
            $t('batch.import.customer.tips')
          }}
        </p>
        <!--        <p><span><el-icon><Warning/></el-icon></span>-->
        <!--          {{ $t('import.file.tip2') }}-->
        <!--        </p>-->
        <!--        <p><span><el-icon><Warning/></el-icon></span>-->
        <!--          {{ $t('import.file.tip3') }}-->
        <!--        </p>-->
        <!--        <p><span><el-icon><Warning/></el-icon></span>-->
        <!--          {{ $t('import.file.tip4') }}-->
        <!--        </p>-->
      </div>
    </div>
    <template #footer>
      <ElButton size="small" @click="close">
        {{ $t('common.cancel') }}
      </ElButton>
      <ElButton v-if="isShowData" type="primary" size="small" @click="close">
        {{ $t('common.close') }}
      </ElButton>
      <ElButton v-else size="small" type="primary" @click="addToEmails" :loading="loading">
        {{ $t('common.confirm') }}
      </ElButton>
    </template>

  </ElDialog>
</template>

<script setup>
import {ElButton, ElDialog, ElInput, ElMessage} from "element-plus";
import {V2CreateTeam} from '../../api'
import {ref, defineProps, watch, defineEmits, reactive, computed, onMounted} from 'vue'
import {useStore} from "vuex";
import {i18n} from "@/lang";
import {
  exportCustomerTemplate,
  getImportCustomerData,
  getMailCustomerList,
  importCustomxerExcel,
  requestAllCustomer
} from "@/api/customer";
import TopSearch from "@/views/Customer/TopComponents/TopSearch.vue";
import * as XLSX from "xlsx";
import Tables from "@/views/Customer/Tables/Tables.vue";
import {table_columns_list, table_columns_list_sp} from "@/views/Customer/map";
import {Download, Warning} from "@element-plus/icons-vue";

const store = useStore();
const emit = defineEmits()
const isShow = ref(false);
const teamName = ref("")
const loading = ref(false);
// 选中的数组
const checkList = ref([])

const {value, isChecked} = defineProps({
  value: {type: Boolean, default: false},
  isChecked: {type: Array, default: []}
})

watch(() => value, (val) => {
  isShow.value = val;
}, {immediate: true})

const teamId = computed(() => store.state.email.teamID);
const isLoading = ref(false);


const showTargetEmails = ref([])
const customerList = ref([])
const percent = ref(0)
const fileList1 = ref([])
const fileTarget = ref(null)

async function handleUploadChange(file, fileList) {
  fileTarget.value = file
  console.log(file, fileTarget.value, 'ffff')
  if (fileList.length > 1) {
    fileList.splice(0, 1);
  }
  fileList1.value = fileList;
}

// 检测上传进度

function extractEmails(data) {
  return data.map(function (entry) {
    return entry["公司邮箱"];
  });
}

const readFile = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (e) => {
      resolve(e.target.result);
    };
    reader.onerror = (e) => {
      reject(e);
    };
  });
}

const isErrorExcel = ref(false)
//收集邮箱并添加
const addToEmails = async () => {
  console.log(fileTarget.value, 'file.value')
  if (!fileTarget.value) {
    ElMessage.warning(i18n.global.t('sys.tip.select.file'))
    return
  }
  const blob = new Blob([fileTarget.value.raw], {type: fileTarget.value.raw.type}); // 使用 file.row 而不是 file
  const formData = new FormData();
  formData.append('file', blob, fileTarget.value.name);
  formData.append('teamId', teamId.value);
  console.log(formData.get('file'), 'fff')
  loading.value = true;
  // 开始显示 进度条
  // 上传请求
  percent.value = 1
  try {
    const res = await importCustomxerExcel(formData, {
      headers: {'Content-Type': 'multipart/form-data'},
      // onUploadProgress: e => {
      //   // 上传进度
      //   const percentCompleted = Math.round((e.loaded * 100) / e.total);
      //   percent.value = percentCompleted;
      // }
    });

    const taskId = res.result;

    let timer = null;
    let lastTotalCount = 0;
    let lastSuccessFail = 0;
    let noChangeCount = 0;
    const MAX_NO_CHANGE_COUNT = 10; // 数据连续多少次没变化就停止

    timer = setInterval(async () => {
      try {
        await getImportCustomerDataApis(taskId);

        const {totalCount = 0, successCount = 0, failCount = 0} = importCustomerMessage.value ?? {};
        const currentSuccessFail = successCount + failCount;

        console.log(importCustomerMessage.value, 'data');

        // 如果数据没有变化，计数
        if (totalCount === lastTotalCount && currentSuccessFail === lastSuccessFail) {
          noChangeCount++;
          if (noChangeCount >= MAX_NO_CHANGE_COUNT) {
            console.warn('任务长时间无变化，停止轮询');
            percent.value = Math.min(percent.value, 100);
            clearInterval(timer);
            loading.value = false;
            isErrorExcel.value = true
            return;
          }
        } else {
          noChangeCount = 0;
        }
        isErrorExcel.value = false
        lastTotalCount = totalCount;
        lastSuccessFail = currentSuccessFail;

        // 计算目标百分比
        const targetPercent = totalCount > 0 ? Math.round((currentSuccessFail / totalCount) * 100) : 0;

        // 平滑增加 percent，不超过目标值
        if (percent.value < targetPercent) {
          console.log(targetPercent - percent.value, 'targetPercent - percent.value')
          // const step = Math.min(targetPercent - percent.value, 5); // 每次最多加 5%
          percent.value = targetPercent
        } else if (percent.value > targetPercent) {
          // 防止后端 totalCount 变化导致 percent 超过目标值
          percent.value = targetPercent;
        }

        // 任务完成
        if (totalCount > 0 && currentSuccessFail >= totalCount) {
          percent.value = 100;
          isShowData.value = true;
          clearInterval(timer);
          loading.value = false;
          console.log('任务完成');
        }

      } catch (err) {
        clearInterval(timer);
        loading.value = false
        console.error('轮询失败:', err);
      }
    }, 3000); // 每 2 秒轮询一次，避免频繁请求

  } catch (error) {
    loading.value = false;
    isShowData.value = true
    console.error('Error uploading file:', error);
  }

}

/**
 * excel 模版下载
 * @type {Ref<UnwrapRef<boolean>>}
 */
const downloadFile = ref(false);
const downloadExcel = async () => {
  await exportCustomerTemplate(_, {
    responseType: "blob",
    headers: {'Content-Type': 'application/vnd.ms-excel'}
  }).then(res => {
    const link = document.createElement('a');
    const blob = new Blob([res], {type: 'application/vnd.ms-excel;charset=utf-8'}); // 设置正确的字符编码
    link.style.display = 'none';
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', i18n.global.t('download.customer.template'));
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  });
};

const cancel = () => {
  emit("close");
  fileList1.value = [];
  fileTarget.value = null;
}
const close = () => {
  cancel()
  if (isShowData.value) {
    emit("getCustomerList");
  }
}

const handleRemove = () => {
  console.log('closeFile')
  fileList1.value = [];
  fileTarget.value = null;
  percent.value = 0;
  isShowData.value = false
}

const importCustomerMessage = ref({totalCount: 0, successCount: 0, failCount: 0})
const formattedMessage = computed(() => {
  const message = i18n.global.t('import.message.customer', {
    total: importCustomerMessage.value?.totalCount ?? 0,
    success: importCustomerMessage.value?.successCount ?? 0,
    failed: importCustomerMessage.value?.failCount ?? 0
  })
  return message
})

const isShowData = ref(false)
const getImportCustomerDataApis = async (id) => {
  try {
    const payload = {id: id}
    const res = await getImportCustomerData(payload)
    console.log(res, 'dddddd')
    importCustomerMessage.value = res.result;
  } catch (e) {

  }
}
</script>

<style scoped lang="less">
@import "../../less/page.less";

.fx-j-c {
  display: flex;
  justify-content: center;
}

.settings {
  margin-top: 40px;
  display: flex;
  justify-content: flex-end;
}

:deep(.el-progress__text) {
  display: none;
}

:deep(.el-upload-list) {
  line-height: 50px;
  width: 250px;
  transform: translateX(-50%);
}

:deep(.el-upload-list__item) {
  left: 50%;
}

:deep(.el-upload-list__item-info) {
  align-items: center !important;
}

:deep(.el-upload-list__item-file-name) {
  font-size: 14px;
  font-weight: 600;
  max-width: 200px !important;
}

:deep(.text_content) {

  & > p {
    line-height: 20px;
    font-weight: 500;
    color: #dca550;
    display: flex;
    align-items: flex-start;
    margin-bottom: 6px;
    justify-content: center;

    & > span {
      padding-top: 2px;
    }

  }
}

.headline > .el-dialog__header {
  border-bottom: 1px solid #eee !important;
}


.headline > .el-dialog__footer {
  border-top: 1px solid #eee !important;
}

.import_message {
  width: 100%;
  padding: 0px 60px;
  text-align: center;
  margin: 20px auto;
  color: #439eff;
}
</style>
